export default __webpack_public_path__ + "4a9632fb906f4f3d2087fe67d9acd949.png";